import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["navigationTag"]

  connect() {
    this.boundMatchNavigationTagToUrl = this.matchNavigationTagToUrl.bind(this)
    document.addEventListener("turbo:load", this.boundMatchNavigationTagToUrl)
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.boundMatchNavigationTagToUrl)
  }

  matchNavigationTagToUrl() {
    let currentPathname = window.location.pathname

    let oldActiveTarget = this.navigationTagTargets.find(target => target.classList.contains("active"))
    let newActiveTarget = this.navigationTagTargets.find(target => target.dataset.pathname === currentPathname)

    if (oldActiveTarget) {
      oldActiveTarget.classList.toggle("active", false)
    }

    if (newActiveTarget) {
      newActiveTarget.classList.toggle("active", true)
    }
  }
}
